// extracted by mini-css-extract-plugin
export var active = "links-module--active--4c510";
export var bottomLinks = "links-module--bottom-links--6c200";
export var branches = "links-module--branches--69972";
export var close = "links-module--close--6fc90";
export var hamburger = "links-module--hamburger--185a6";
export var lastLi = "links-module--last-li--a18e5";
export var linkItem = "links-module--link-item--7de27";
export var links = "links-module--links--e3fe7";